const init = () => {
	document.addEventListener('DOMContentLoaded', function () {
		const leaderboardTop = document.querySelector(
			'.dfp-ad.dfp-leaderboard_top'
		);
		window.hmUtils.isMobile() &&
			leaderboardTop &&
			leaderboardTop.classList.add('lt-mobile');
		const mainNav = document.getElementById('main-nav');
		const menuToggle = document.getElementById('menu-toggle');
		menuToggle &&
			menuToggle.addEventListener('click', function (event) {
				if (mainNav.classList.contains('active')) {
					mainNav.classList.remove('active');
					this.setAttribute('aria-expanded', 'false');
				} else {
					mainNav.classList.add('active');
					this.setAttribute('aria-expanded', 'true');
				}
			});
		const enterKeyCode = 13;
		const spacebarKeyCode = 32;
		menuToggle &&
			menuToggle.addEventListener('keyup', function (event) {
				if (
					event.keyCode === enterKeyCode ||
					event.keyCode === spacebarKeyCode
				) {
					if (mainNav.classList.contains('active')) {
						mainNav.classList.remove('active');
						this.setAttribute('aria-expanded', 'false');
						this.setAttribute('aria-label', 'Open Menu');
					} else {
						mainNav.classList.add('active');
						this.setAttribute('aria-expanded', 'true');
						this.setAttribute('aria-label', 'Close Menu');
					}
				}
			});
		//scrolling requirement
		const observerTarget = document.getElementById('nav-marker');
		function observerOnEntry(entry) {
			entry.forEach((change) => {
				if (change.boundingClientRect.y < 0) {
					document.getElementById('page').classList.add('scrolled');
				} else {
					document
						.getElementById('page')
						.classList.remove('scrolled');
				}
			});
		}
		let options = {
			threshold: [0.5],
		};
		let observer = new IntersectionObserver(observerOnEntry, options);
		observerTarget && observer.observe(observerTarget);

		// Sustain the select state through all the tabs within the “Your Journey” experience.
		const journeyMenuLink = document.querySelector('#primary-menu').querySelector('a[href="/journeys/diagnosis-seekers/"]'); // your journey menu link
		const journeyTerms = document.querySelectorAll('.journey-terms .journey-container li a'); // All journey terms/tabs
		journeyTerms.length && journeyTerms.forEach(function( elem ) {
			if( elem.href === location.href ) {
				journeyMenuLink && journeyMenuLink.parentElement.classList.add('current-menu-item'); //highlight journey menu
			}
		});
	});
};

// Exports
export { init };
